import React from "react";
import { motion } from "framer-motion";

const TermsAndConditions = () => {
  const fadeIn = {
    hidden: { opacity: 0, y: 40 },
    show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
  };

  return (
    <div
      className="min-h-screen text-white py-20 px-6 md:px-20"
      style={{
        background: "linear-gradient(135deg, #0A2545 0%, #0D5E63 100%)",
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-center mb-16"
      >
        <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-teal-300 to-cyan-200 drop-shadow-md">
          Terms & Conditions
        </h1>
        <p className="text-gray-300 mt-4 max-w-3xl mx-auto">
          Welcome to Yes Auto. Please read these Terms carefully before using our services.
        </p>
      </motion.div>

      <div className="space-y-12 max-w-5xl mx-auto">
        {[
          {
            title: "1. Purpose of Our Service",
            text: "Yes Auto is a car lead generation and financing referral platform. Our role is to connect you with our trusted network of automotive dealerships, lenders, and financial service providers who may offer financing or leasing options suited to your needs. We are not a lender or credit provider and do not make credit decisions or provide loans directly. All financing approvals, rates, and terms are determined by our Partners.",
          },
          {
            title: "2. Information You Provide",
            text: "When you submit your information on Yes Auto, you agree that you are at least 18 years old, the information provided is accurate, and you authorize Yes Auto and its Partners to contact you by phone, email, or text regarding financing opportunities, even if your number is on a Do Not Call list.",
          },
          {
            title: "3. Credit Authorization",
            text: "By submitting a financing request through Yes Auto, you authorize our Partners to obtain your credit report, evaluate your eligibility, and contact you directly regarding financing options. Multiple lenders may access your credit file, which may result in several inquiries.",
          },
          {
            title: "4. Sharing of Information",
            text: "We may share your information with automotive dealers, lenders, or service providers who help process your application. Your personal data is never sold to unrelated third parties without your consent. For more information, see our Privacy Policy.",
          },
          {
            title: "5. No Guarantee of Approval",
            text: "Submitting an application through Yes Auto does not guarantee financing approval. Decisions, interest rates, and terms depend entirely on our Partner dealers or lenders based on your credit history and income.",
          },
          {
            title: "6. Limitation of Liability",
            text: "Yes Auto is not responsible for any credit decision, rate, or offer made by third parties, or any loss, damage, or dispute resulting from your dealings with them. All services are provided “as is” without any warranty.",
          },
          {
            title: "7. User Responsibilities",
            text: "You agree not to provide false or misleading information, use the site for fraudulent activity, or attempt to interfere with our system security or functionality.",
          },
          {
            title: "8. Modifications",
            text: "We may update or modify these Terms at any time. Changes will be posted on our website, and continued use of the site means you accept those changes.",
          },
          {
            title: "9. Governing Law",
            text: "These Terms are governed by the laws of the Province of Alberta and Canada, without regard to conflicts of law principles.",
          },
        ].map((section, index) => (
          <motion.div
            key={index}
            variants={fadeIn}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            className="bg-white/10 backdrop-blur-md p-8 rounded-2xl shadow-lg border border-white/10 hover:border-teal-400/30 transition-all duration-500"
          >
            <h2 className="text-2xl font-semibold text-teal-300 mb-4">
              {section.title}
            </h2>
            <p className="text-gray-200 leading-relaxed">{section.text}</p>
          </motion.div>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.8 }}
        className="text-center mt-20 text-gray-400"
      >
        <p>
          Last updated: <span className="text-teal-300">November 2025</span>
        </p>
      </motion.div>
    </div>
  );
};

export default TermsAndConditions;
